import moment from 'moment';
import io from 'socket.io-client';
import {addMiddleware, removeMiddleware} from 'redux-dynamic-middlewares';
import socketMiddleware from '../../store/actions/action-websocket';

class SocketController {
  constructor() {
    this.sockets = new Map();
  }

  createSocket = (name, hostname, options = {}) => {
    if (this.sockets.get(name)) {
      this.sockets.get(name).disconnect();
      removeMiddleware(this.sockets.get(name).middleware);
    }

    let host = hostname;
    if (options.extraHeaders && options.extraHeaders.Authorization) {
      host += `?authorization=${options.extraHeaders.Authorization}`;
    }

    const socket = io.connect(host, {...options, transports: ['websocket']});

    socket.on('connect', () => {
      this.log(`connected to ${name} ${hostname}, socketId: ${socket.id}`);
    });
    socket.on('disconnect', () => {
      this.log(`disconnected from ${name}`);
    });
    socket.on('reconnecting', () => {
    });
    socket.on('reconnect', () => {
    });
    socket.on('reconnect_error', (error) => {
      this.log(`socket reconnect error: ${error}`);
    });
    socket.on('reconnect_failed', (error) => {
      this.log(`socket reconnect failed: ${error}`);
    });
    socket.on('error', (error) => {
      this.log(`socket error ${host}: ${error}`);
    });

    socket.listeners = {};
    socket.subscribedSocketUpdate = {};
    socket.subscribeUpdateSocket = this.subscribeUpdateSocket(socket);
    socket.unsubscribeUpdateSocket = this.unsubscribeUpdateSocket(socket);

    if (this.sockets.get(name) && this.sockets.get(name).subscribedSocketUpdate) {
      Object.values(this.sockets.get(name).subscribedSocketUpdate).forEach((handler) => handler(socket));
    }
    this.sockets.set(name, socket);

    const {middleware} = this.handleCreateSocket(name, socket);

    socket.middleware = middleware;

    return socket;
  };

  handleCreateSocket = (name, socket) => {
    const middleware = socketMiddleware(socket);
    addMiddleware(middleware);
    return {middleware};
  };

  getSocket = (socket) => this.sockets.get(socket);

  log = (message) => {
    console.log(`${moment().format('HH:MM:ss')} - SocketService: ${message}`);
  };

  subscribeUpdateSocket = (socket) => (name, callback) => {
    socket.subscribedSocketUpdate[name] = callback;
  };

  unsubscribeUpdateSocket = (socket) => (name) => {
    delete socket.subscribedSocketUpdate[name];
  };
}

const socketController = new SocketController();

export default socketController;
